import type { HTMLAttributes } from "react";

export default function CameraIcon(props: HTMLAttributes<HTMLDivElement>) {
  return (
    <div {...props}>
      <svg
        width="15"
        height="14"
        viewBox="0 0 15 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.125 12.5625H1.875C1.57663 12.5625 1.29048 12.444 1.0795 12.233C0.868526 12.022 0.75 11.7359 0.75 11.4375V3.5625C0.75 3.26413 0.868526 2.97798 1.0795 2.76701C1.29048 2.55603 1.57663 2.4375 1.875 2.4375H4.12459L5.24959 0.75H9.74959L10.8746 2.4375H13.125C13.4234 2.4375 13.7095 2.55603 13.9205 2.76701C14.1315 2.97798 14.25 3.26413 14.25 3.5625V11.4375C14.25 11.7359 14.1315 12.022 13.9205 12.233C13.7095 12.444 13.4234 12.5625 13.125 12.5625Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.5 9.75C8.89797 9.75 10.0312 8.61672 10.0312 7.21875C10.0312 5.82078 8.89797 4.6875 7.5 4.6875C6.10203 4.6875 4.96875 5.82078 4.96875 7.21875C4.96875 8.61672 6.10203 9.75 7.5 9.75Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
}
